<template>
  <div>
    <v-row>
      <v-col cols="12" sm="7">
        <v-skeleton-loader height="150" type="list-item-three-line" class="mx-auto"></v-skeleton-loader>
      </v-col>
      <v-col cols="12" sm="5">
        <v-skeleton-loader height="150" type="image" class="mx-auto"></v-skeleton-loader>
      </v-col>
    </v-row>
    <h2 class="mb-7">Carte en cours</h2>
    <v-skeleton-loader height="150" type="image" class="mx-auto"></v-skeleton-loader>
  </div>
</template>

<script>
  export default {};
</script>


